import { SEED_QUOTES } from "./mockQuotes";

/**
 * Repositorio local de cotizaciones.
 *
 * Persistencia temporal en localStorage para el mockup.
 * Futuro: reemplazar la implementación interna por Supabase
 * sin cambiar la interfaz list/getById/create/update/remove.
 */

const STORAGE_KEY = "denegocios_cotizaciones_mock_v1";

const readStorage = () => {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (!raw) {
			localStorage.setItem(STORAGE_KEY, JSON.stringify(SEED_QUOTES));
			return [...SEED_QUOTES];
		}
		const parsed = JSON.parse(raw);
		return Array.isArray(parsed) ? parsed : [...SEED_QUOTES];
	} catch (error) {
		console.warn("No se pudo leer cotizaciones mock:", error);
		return [...SEED_QUOTES];
	}
};

const writeStorage = (quotes) => {
	localStorage.setItem(STORAGE_KEY, JSON.stringify(quotes));
};

export const quoteRepository = {
	async list() {
		return readStorage();
	},

	async getById(id) {
		const quotes = readStorage();
		return quotes.find((quote) => quote.id === id) || null;
	},

	async create(data) {
		const quotes = readStorage();
		const created = {
			...data,
			id: data.id || `quote-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
			createdAt: data.createdAt || new Date().toISOString(),
			updatedAt: new Date().toISOString(),
		};
		quotes.unshift(created);
		writeStorage(quotes);
		return created;
	},

	async update(id, data) {
		const quotes = readStorage();
		const index = quotes.findIndex((quote) => quote.id === id);
		if (index === -1) throw new Error("Cotización no encontrada");
		const updated = {
			...quotes[index],
			...data,
			id,
			updatedAt: new Date().toISOString(),
		};
		quotes[index] = updated;
		writeStorage(quotes);
		return updated;
	},

	async remove(id) {
		const quotes = readStorage().filter((quote) => quote.id !== id);
		writeStorage(quotes);
		return true;
	},

	/** Utilidad de desarrollo: restaura seeds. */
	async reset() {
		writeStorage([...SEED_QUOTES]);
		return readStorage();
	},
};
